const RequestType = {
  ECG: 'ecg',
} as const;

type RequestType = typeof RequestType[keyof typeof RequestType];

export { RequestType };
